module.exports = __webpack_public_path__ + "img/concept.e2ac45fa.png";